import * as z from "zod/v4";

export const getAutocompleteSuggestions = {
  name: "getAutocompleteSuggestions" as const,
  input: z.object({
    query: z.string().min(0),
    sessionToken: z.string().optional(),
  }),
  output: z.object({
    suggestions: z.array(
      z.object({ displayText: z.string(), keyToFullObject: z.string() }),
    ),
  }),
};
